(function () {
    'use strict';

    /**
     * @ngdoc factory
     * @name print.factory:PrintRequestFactory
     *
     * @description
     *
     */
    angular
        .module('print')
        .factory('PrintRequestFactory', PrintRequestFactory);

    function PrintRequestFactory() {

        var printDGRQ = function (blockId, crewTypes, crewScheduleEventId) {
            return {
                blockID : blockId,
                crewTypes : crewTypes || [],
                crewScheduleEventId : crewScheduleEventId
            }
        };
        
        var gdDisplayModel = function () {
            return {
                operator: null,
                flightNumbers: null,
                acModels: null,
                dates:null,
                registrationNos:null,
                departureFrom:null,
                arrivalAt:null,
                route :null,
                onds:[],
                staffs:[]
            }
        };

        var GDCrew = function () {
            return {
                staffNo:null,
                name:null,
                rank:null,
                nationalityAbb:null,
                gender:null,
                passportNo:null,
                unifiedId:null,
                remarks:null,
                dateOfBirth:null
            }
        }
        
        var GetPrintJourneyRQ = function(params){
        	return{
        		blockId :params.blockId,
        		version :params.version,
        		crewScheduleEventId :params.crewScheduleEventId,
        		isUpdate :false
        	}
        };
        
        var GetCrewDataList = function(){
        	return{
        		staffNo:null,
                name:null,
                rank:null,
                nationalityAbb:null,
                gender:null,
                passportNo:null,
                unifiedId:null,
                remarks:null,
                dateOfBirth:null,
                start :null
        		
        	}
        };

        return {
            getPrintGDRQ : printDGRQ,
            getGDDisplayModel: gdDisplayModel,
            getGDCrew:GDCrew,
            getPrintJourneyRQ :GetPrintJourneyRQ,
            getCrewDataList :GetCrewDataList
        }
    }
    })();